import React, {useContext} from "react";
import {Box, Dialog, DialogContent, DialogContentText, DialogTitle,DialogActions, Divider, IconButton,Button} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {exceptionsTitle} from "../../../dictionaries";
import {DealsPageContext} from "../index";
import {copyDeal, deleteDeal} from "../dealsApi";
import {getBackendURL} from "../../../fn";
import { DialogWindow } from "../../../domains/common/components/Dialog";
import { ButtonBase } from "../../../domains/common/components/Button";

export const DealListActionMenu = React.memo(({dealId, status}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openModal,setOpenModal] = React.useState(false)
  const {openEventsDrawer, loadDealsData, openNotify} = useContext(DealsPageContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const showDealEvents = async () => {
    setAnchorEl(null)
    openEventsDrawer(dealId)
  }

  const handleCopyDeal = async () => {
    setAnchorEl(null);
    const result = await copyDeal(dealId);

    if (result.ok) {
      openNotify({msg: "Сделка скопирована успешно", duration: 2000, type: 'success'});
      loadDealsData();
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || result.message || "Не удалось копировать сделку",
        duration: 5000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${getBackendURL()}/deal/${dealId}/download`;
    link.click();
  };

  const handleDeleteDeal = async () => {
    setAnchorEl(null);
    const result = await deleteDeal(dealId);

    if (result.ok) {
      openNotify({msg: "Сделка удалена", duration: 2000, type: 'success'});
      loadDealsData();
      setOpenModal(false)
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || result.message || "Не удалось получить список сделок",
        duration: 5000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  const handleClose = (e) => {
    setAnchorEl(null);
  };
  const actionBtns = (<><DialogActions sx={{display:"flex",justifyContent:'space-between',paddingX:3,paddingBottom:2}}>
          <ButtonBase color="error" variant="contained" onClick={handleDeleteDeal} autoFocus>
            Удалить
          </ButtonBase>
          <ButtonBase color="info" variant="contained" onClick={() => setOpenModal(false)}>Отменить</ButtonBase>
        </DialogActions></>)
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon/>
      </IconButton>
      <Menu
        id="long-menu"
        disableScrollLock={true}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              width: '150px',
            },
          },
          list: {
            'aria-labelledby': 'long-button',
          },
        }}
      >
        {status === 'dealCompleted' ?
          <>
            <MenuItem key='copyDeal' onClick={handleDownload}>
              Скачать архив
            </MenuItem>
            <Divider/>
          </> : void 0
        }
        <MenuItem key='dealEvents' onClick={showDealEvents}>
          События
        </MenuItem>
        <Divider/>
        <MenuItem key='copyDeal' onClick={handleCopyDeal}>
          Копировать
        </MenuItem>
        <MenuItem key='deleteDeal' onClick={() => setOpenModal(true)}>
          Удалить
        </MenuItem>
      </Menu>
      <DialogWindow isOpen={openModal} 
      onClose={() => setOpenModal(false)} 
      dialogTitle={'Удалить сделку'} 
      dialogText={'Внимение! После удаления сделки вы потеряете к ней доступ'}
      actions={actionBtns}/>
    </div>
    
  );
})